import { CategoryScale, Chart as ChartJS, LinearScale, LineController, LineElement, PointElement, Title, Tooltip } from 'chart.js';
import { Card } from 'react-bootstrap';
import './ApiIntegrationCard.scss';
ChartJS.register(LineController, LineElement, PointElement, CategoryScale, LinearScale, Title, Tooltip);

interface Props {
    link: string;
    title: string;
    description: string;
    logo: React.ReactNode;
}


const ApiIntegrationCard = ({ title, description, link, logo }: Props) => {
    const onClick = () => {
        window.open(link, '_blank');
    };
    return (
        <Card className="api-integration-card" onClick={onClick}>
            <Card.Body>
                {logo}
                <Card.Title style={{ fontWeight: 'bold' }}>{title}</Card.Title>
                <Card.Text>
                    {description}
                </Card.Text>
            </Card.Body>
        </Card>
    )
}

export default ApiIntegrationCard